import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EventUsersPage } from './event-users';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    EventUsersPage,
  ],
  imports: [
		PipesModule,
    IonicPageModule.forChild(EventUsersPage),
  ],
})
export class EventUsersPageModule {}



// WEBPACK FOOTER //
// ./src/pages/event-users/event-users.module.ts